module.exports = __webpack_public_path__ + "img/tu8@2x.6111d6bd.png";